import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: '首页',
    EnName: 'Home',
    component: () => import('../views/Home.vue'),
    redirect: '/index',
    meta: {
      showMap: true,
      bannerConsSaver: true,
      EnName: 'Home',
    },
    children: [{
        path: '/',
        name: '首页',
        EnName: 'Home',
        meta: {
          EnName: 'Home',
          seo: 'defaultSeo',
          seoRequestUrl: '/api/Index/index',
          showMap: true, //是否显示底部地图
          showSelect: true, //显示地图内折叠面板
          bannerConsSaver: true, // 是否显示头部轮播图下的选项
          bannerHeight: 450, // 页面轮播图高度
          bannerList: [{
              img: require("../assets/header/Banner1.jpg"),
              id: 1,
            },
            {
              img: require("../assets/header/Banner2.jpg"),
              id: 2,
            },
            {
              img: require("../assets/header/Banner3.jpg"),
              id: 3,
            }
          ], // 轮播图列表
        },
        hidden: false, // 是否有下级折叠面板
        component: () => import('../views/Index.vue'),
      },
      {
        path: '/about',
        name: '关于我们',
        EnName: 'About Us',
        meta: {
          seo: 'defaultSeo',
          EnName: 'About Us',
          seoRequestUrl: '/api/about/index',
          showMap: true,
          bannerConsSaver: false,
          bannerHeight: 450,
          showSelect: true,
          // bannerList: [{
          // 	img: require("../assets/About/banner.jpg"),
          // 	id: 1,
          // }],
        },
        hidden: false,
        component: () => import('../views/About.vue')
      },
      {
        path: '/InternationalLogisticsServices',
        // name: '国际物流服务',
        name: '我们的服务',
        EnName: 'Our Service',
        meta: {
          showMap: true,
          EnName: 'Our Service',
          bannerConsSaver: false,
          bannerHeight: 450,
          bannerList: [{
            img: require("../assets/About/banner.jpg"),
            id: 1,
          }, ],
        },
        component: () => import('../views/InternationalLogisticsServices/chinaEurope/chinaEurope.vue'),
        redirect: '/chinaEurope',
        hidden: true,
        children: [{
            path: '/chinaEurope',
            name: '中欧运输',
            EnName: 'China-Europe Transportation',
            meta: {
              EnName: 'China-Europe Transportation',
              showMap: false,
              bannerConsSaver: false,
              bannerHeight: 450,
              bannerList: [{
                img: require("../assets/About/banner.jpg"),
                id: 1,
              }],

            },
            component: () => import(
              '../views/InternationalLogisticsServices/chinaEurope/chinaEurope.vue'),
            redirect: '/chinaEuropeTrain',
            hidden: true,
            children: [{
                path: '/chinaEuropeTrain',
                name: '中欧班列',
                EnName: 'China-Europe Railway Express',
                meta: {
                  EnName: 'China-Europe Railway Express',
                  showMap: false,
                  bannerConsSaver: false,
                  bannerHeight: 450,
                  bannerList: [{
                    img: require("../assets/About/banner.jpg"),
                    id: 1,
                  }],
                  ioco: '丨',
                  seo: 'serveSeo',
                  seoId: 34 // 栏目id
                },
                component: () => import(
                  '../views/InternationalLogisticsServices/chinaEurope/chinaEuropeTrain.vue'
                ),
                hidden: true,
              },
              {
                path: '/chinaEuropeOceanShipping',
                name: '海铁联运',
                EnName: 'China Europe Sea Rail',
                meta: {
                  showMap: false,
                  EnName: 'China Europe Sea Rail',
                  bannerConsSaver: false,
                  bannerHeight: 450,
                  bannerList: [{
                    img: require("../assets/About/banner.jpg"),
                    id: 1,
                  }],
                  ioco: false,
                  seo: 'serveSeo',
                  seoId: 33

                },
                component: () => import(
                  '../views/InternationalLogisticsServices/chinaEurope/chinaEuropeOceanShipping.vue'
                ),
                hidden: true,
              },
            ],

          },
          {
            path: '/CR_overseasServiceProvider',
            name: '中欧班列境外服务商',
            EnName: 'Business Service',
            meta: {
              showMap: false,
              EnName: 'Business Service',
              bannerConsSaver: false,
              bannerHeight: 450,
              bannerList: [{
                img: require("../assets/About/banner.jpg"),
                id: 1,
              }],
              ioco: '丨',
              seo: 'serveSeo',
              seoId: 38

            },
            component: () => import(
              '../views/InternationalLogisticsServices/chinaAndRussia/CR_overseasServiceProvider.vue'
            ),
            hidden: false,
          },
          {
            path: '/chinaAndRussia',
            // name: '中俄物流',
            name: '中俄运输',
            EnName: 'China Russian Logistics',
            meta: {
              EnName: 'China Russian Logistics',
              showMap: false,
              bannerConsSaver: false,
              bannerHeight: 450,
              // bannerList: [{
              // 	img: require("../assets/About/banner.jpg"),
              // 	id: 1,
              // }],
            },
            component: () => import(
              '../views/InternationalLogisticsServices/chinaAndRussia/chinaAndRussia.vue'
            ),
            redirect: '/CR_sinoRussianRailway',
            hidden: true,
            children: [{
                path: '/CR_sinoRussianRailway',
                name: '中俄运输',
                EnName: 'China Russian Logistics',
                meta: {
                  showMap: false,
                  EnName: 'China Russian Logistics',
                  bannerConsSaver: false,
                  bannerHeight: 450,
                  bannerList: [{
                    img: require("../assets/About/banner.jpg"),
                    id: 1,
                  }],
                  ioco: '丨',
                  seo: 'serveSeo',
                  seoId: 36
                },
                component: () => import(
                  '../views/InternationalLogisticsServices/chinaAndRussia/CR_sinoRussianRailway.vue'
                ),
                hidden: true,
              },
              {
                path: '/CR_airServices',
                name: '空运服务',
                EnName: 'Air Freight Service',
                meta: {
                  showMap: false,
                  EnName: 'Air Freight Service',
                  bannerConsSaver: false,
                  bannerHeight: 450,
                  bannerList: [{
                    img: require("../assets/About/banner.jpg"),
                    id: 1,
                  }],
                  ioco: '丨',
                  seo: 'serveSeo',
                  seoId: 37

                },
                component: () => import(
                  '../views/InternationalLogisticsServices/chinaAndRussia/CR_airServices.vue'
                ),
                hidden: true,
              },
              {
                path: '/CR_oceanShipping',
                name: '国际海运',
                EnName: 'International Shipping',
                meta: {
                  showMap: false,
                  EnName: 'International Shipping',
                  bannerConsSaver: false,
                  bannerHeight: 450,
                  bannerList: [{
                    img: require("../assets/About/banner.jpg"),
                    id: 1,
                  }],
                  ioco: false,
                  seo: 'serveSeo',
                  seoId: 42

                },
                component: () => import(
                  '../views/InternationalLogisticsServices/chinaAndRussia/CR_oceanShipping.vue'
                ),
                hidden: true,
              },
              {
                path: '/CR_automobileTransportation',
                name: '国际汽运',
                EnName: 'International Land Transport',
                meta: {
                  EnName: 'International Land Transport',
                  showMap: false,
                  bannerConsSaver: false,
                  bannerHeight: 450,
                  bannerList: [{
                    img: require("../assets/About/banner.jpg"),
                    id: 1,
                  }],
                  ioco: '丨',
                  seo: 'serveSeo',
                  seoId: 41

                },
                component: () => import(
                  '../views/InternationalLogisticsServices/chinaAndRussia/CR_automobileTransportation.vue'
                ),
                hidden: true,
              },
              // {
              // 	path: '/CR_customsClearance',
              // 	name: '清关服务',
              // 	EnName: 'Customs Clearance Service',
              // 	meta: {
              // 		EnName: 'Customs Clearance Service',
              // 		showMap: false,
              // 		bannerConsSaver: false,
              // 		bannerHeight: 450,
              // 		bannerList: [{
              // 			img: require("../assets/About/banner.jpg"),
              // 			id: 1,
              // 		}],
              // 		ioco: '丨',
              // 		seo: 'serveSeo',
              // 		seoId: 38

              // 	},
              // 	component: () => import(
              // 		'../views/InternationalLogisticsServices/chinaAndRussia/CR_customsClearance.vue'
              // 	),
              // 	hidden: true,
              // },
              {
                path: '/CR_overseasTransportation',
                name: '境外承运',
                EnName: 'Overseas transportation',
                meta: {
                  EnName: 'Overseas transportation',
                  showMap: false,
                  bannerConsSaver: false,
                  bannerHeight: 450,
                  bannerList: [{
                    img: require("../assets/About/banner.jpg"),
                    id: 1,
                  }],
                  ioco: '丨',
                  seo: 'serveSeo',
                  seoId: 43
                },
                component: () => import(
                  '../views/InternationalLogisticsServices/chinaAndRussia/CR_overseasTransportation.vue'
                ),
                hidden: true,
              },

            ],

          },
          {
            path: '/freightTracking',
            name: 'MG物流云系统',
            EnName: 'Logistics Cloud Platform',
            meta: {
              // seo: 'serveSeo',
              // seoId: 32, // 栏目id
              EnName: 'Logistics Cloud Platform',
              seoRequestUrl: '/api/Freight/Freight/index',
              showMap: false,
              bannerConsSaver: false,
              bannerHeight: 450,
              // bannerList: [{
              // 	img: require("../assets/About/banner.jpg"),
              // 	id: 1,
              // }],
              // ioco: '丨',
            },
            component: () => import(
              '../views/InternationalLogisticsServices/freightTracking/freightTracking.vue'
            ),
            hidden: false,
          },
        ],
      },
      {
        path: '/OverseasWarehouse',
        name: '海外仓',
        EnName: 'Overseas House',
        meta: {
          EnName: 'Overseas House',
          showMap: false,
          bannerConsSaver: false,
          bannerHeight: 450,
          // bannerList: [{
          // 	img: require("../assets/About/banner.jpg"),
          // 	id: 1,
          // }],
          seo: 'serveSeo',
          seoId: 32 // 栏目id
        },
        hidden: false,
        component: () => import('../views/OverseasWarehouse/OverseasWarehouse.vue')
      },
      {
        path: '/internationalTrade',
        name: '国际贸易',
        EnName: 'International Trade',
        meta: {
          EnName: 'International Trade',
          showMap: false,
          bannerConsSaver: false,
          bannerHeight: 450,
          // bannerList: [{
          // 	img: require("../assets/About/banner.jpg"),
          // 	id: 1,
          // }],
          seo: 'serveSeo',
          seoId: 39
        },
        hidden: false,
        component: () => import('../views/internationalTrade/internationalTrade.vue')
      },
      // {
      // 	path: '/businessServices',
      // 	name: '商务服务',
      // 	meta: {
      // 		showMap: false,
      // 		bannerConsSaver: false,
      // 		bannerHeight: 450,
      // 		// bannerList: [{
      // 		// 	img: require("../assets/About/banner.jpg"),
      // 		// 	id: 1,
      // 		// }],
      // 		seo: 'serveSeo',
      // 		seoId: 40
      // 	},
      // 	hidden: false,
      // 	component: () => import('../views/businessServices/businessServices.vue')
      // },
      {
        path: '/newsCenter',
        name: '新闻中心',
        EnName: 'News',
        meta: {
          EnName: 'News',
          showMap: false,
          bannerConsSaver: false,
          bannerHeight: 280,
          showSelect: false,
          // bannerList: [{
          // 	img: require("../assets/About/banner.jpg"),
          // 	id: 1,
          // }],
          // seo: 'serveSeo',
          // seoRequestUrl: '/api/Contactus/index'
        },
        hidden: false,
        component: () => import('../views/newsCenter/newsCenter.vue'),
      },
      {
        path: '/contactUs',
        name: '联系我们',
        EnName: 'Contact Us',
        meta: {
          EnName: 'Contact Us',
          showMap: true,
          bannerConsSaver: false,
          bannerHeight: 450,
          showSelect: false,
          // bannerList: [{
          // 	img: require("../assets/About/banner.jpg"),
          // 	id: 1,
          // }],
          seo: 'contactUsSeo',
          seoRequestUrl: '/api/Contactus/index'
        },
        hidden: false,
        component: () => import('../views/contactUs/contactUs.vue')
      },
    ]
  },
  {
    path: '/newsDetail',
    name: '新闻中心',
    EnName: 'Press Center',
    meta: {
      showMap: false,
      bannerConsSaver: false,
      bannerHeight: 280,
      showSelect: false,
      EnName: 'Press Center',
      // bannerList: [{
      // 	img: require("../assets/About/banner.jpg"),
      // 	id: 1,
      // }],
      // seo: 'serveSeo',
      // seoRequestUrl: '/api/Contactus/index'
    },
    hidden: false,
    component: () => import('../views/newsCenter/newsDetail/newsDetail.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  // base: process.env.BASE_URL,
  base: '/mobile_h5/',
  routes
})

export default router